//表单验证
function checkform(){
	var cate  = $("#cid");
	var title = $("#title");
	var word  = $("#word");
	var tag1  = $("#tag1").val();
	var tag2  = $("#tag2").val();
	var tag3  = $("#tag3").val();
	var pkeywords1  = $("#pkeywords1").val();
	var pkeywords2  = $("#pkeywords2").val();
	var pkeywords3  = $("#pkeywords3").val();
	var catename = $("#catename");
	// var editor = new UE.Editor();
    var ue = UE.getEditor('container',{
     toolbars: [["undo","redo","|","bold","italic","underline","strikethrough","|","fontsize","forecolor","backcolor","|","removeformat","|","selectall","cleardoc","source","|","unlink","link","|","insertimage"]],wordCount:false
    });
    if(ue.queryCommandState('source')==1)
    {
    	ue.execCommand('source');
    }
	switch(''){
		case cate.val():
			swal('请选择分类');
			cate.focus();
			return false;
			break;
		case title.val():
			swal('请填写名称！');
			title.focus();
			return false;
			break;
		case catename.val():
			swal('分类名称不能为空！');
			catename.focus();
			return false;
			break;
		case word.val():
			swal('自定义目录不能为空！');
			word.focus();
			return false;
			break;
		default:
			break;
	}

/*	if(tag1 == '' && tag2 == '' && tag3 == ''){
      alert('请填写关键词！');
      return false;
	}

	if(pkeywords1 == '' && pkeywords2 == '' && pkeywords3 == ''){
      alert('请配置关键词！');
      return false;
	}*/

	return true;
}
